import React from 'react'
import { createRoot } from 'react-dom/client'

import { StateProvider } from './store'
import { App } from './App'
import './index.module.css'

const root = createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <StateProvider>
      <App basename="/help-centre" />
    </StateProvider>
  </React.StrictMode>,
)
